var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Link } from 'react-router-dom';
import { StyledTableBodyCell, StyledButton, StyledTypography } from './styled';
function TitleCell(props) {
    const { href, title, icon } = props, restProps = __rest(props, ["href", "title", "icon"]);
    return (<StyledTableBodyCell headers="filesystemtable-name" {...restProps}>
      {href ? (<StyledButton as={Link} to={href} appearance="ghost">
          <StyledTypography $appearance="300">{title}</StyledTypography>
          {icon}
        </StyledButton>) : (<StyledTypography $appearance="300">{title}</StyledTypography>)}
    </StyledTableBodyCell>);
}
export default TitleCell;
